<template>
    <!-- NAVBAR -->
    <nav id="navBar">
    
      <span id="navBarBrand" target="Home">CMDT</span>
      <span id="navToggler">MENU</span>

      <div id="navMenu" class="collapse">
        <span class="navMenuItem" target="Download">DONWLOAD</span>
        <span class="navMenuItem" target="Controls">CONTROLS</span>
        <span class="navMenuItem" target="Screenshots">SCREENSHOTS</span>
        <span class="navMenuItem" target="Contact">CONTACT</span>
      </div>

    </nav>
    <!-- END OF NAVBAR -->
</template>


<script>

export default {
   mounted(){
   this.navToggler=document.getElementById("navToggler");
   this.navMenu=document.getElementById("navMenu");
   this.navBarBrand=document.getElementById("navBarBrand");
   this.resizeHandler();
   this.setNavBarLinks();
   },

methods:{
    toggleMenu:function(e,forceClose,url) {



      if(this.navToggler){ 
        var visibility = window.getComputedStyle(this.navToggler, null).getPropertyValue("visibility");
        var style = window.getComputedStyle(this.navMenu, null).getPropertyValue("max-Height");
        }

        if(url){this.goTo=url}else{this.goTo='';}
  
          if(visibility==="visible"){
  
            if(forceClose && style!=="0px"){

              this.navMenu.style.animationName = 'collapse';
              
              }else if(style!=="0px"){

                this.navMenu.style.animationName = 'collapse';

              }
               else if(!forceClose){this.goTo='';this.navMenu.style.animationName = 'expand';}
               else if(forceClose){this.GOTO();}
  
          }else{this.GOTO();}

      },
      addNavButtonAnimation:function(e){ this.stopPropagation(e); e.target.style.animationName = 'flicker'; },
      toggle:function(e){ this.stopPropagation(e);e.target.style.animationName = 'flicker'; this.toggleMenu(e); },
      GOTO:function(){

        if(this.goTo!==''){
          
          this.$router.push({ name:this.goTo });
          this.goTo='';

        }
        //                 window.open(this.goTo,"_self"); this.goTo='';}; 

      },
      resizeHandler:function() {

        if(this.navToggler){
            var visibility = window.getComputedStyle(this.navToggler, null).getPropertyValue("visibility");
            var style = window.getComputedStyle(this.navMenu, null).getPropertyValue("max-height");

            if(visibility!=="visible" && style==="0px"){
                this.navMenu.style.maxHeight="512px";
          }else if(visibility==="visible"){this.navMenu.style.maxHeight="0px";};
        
        }
      },
      setNavBarLinks:function(){
          
          var parent=this;
            
            if(this.navToggler){

            var elems=navMenu.getElementsByTagName("span");
            
              for(var i=0; i < elems.length; i++){
            
                if(this.isMobile){elems[i].addEventListener("touchstart",this.addNavButtonAnimation,false);}
                else{elems[i].addEventListener("mousedown",this.addNavButtonAnimation,false);}
                       
                       
                       elems[i].addEventListener('animationend', function(e){


                        e.target.style.animationName = ''; 
                        parent.toggleMenu(e,false,e.target.getAttribute("target"));

                      }, false);
                      
              }
            
              if(this.isMobile){this.navToggler.addEventListener("touchstart",this.toggle,false);}
              else{this.navToggler.addEventListener("mousedown",this.toggle,false);}
            
                     this.navToggler.addEventListener('animationend', function(e){
                      e.target.style.animationName = '';
                    }, false);
              
          
                     this.navMenu.addEventListener('animationend', function(e){

                      if(e.target.style.animationName==="collapse") {e.target.style.maxHeight="0px";parent.GOTO();}
                      else if(e.target.style.animationName==="expand") {e.target.style.maxHeight="100px";}
                      
                      e.target.style.animationName = '';
            
                     }, false);
            
            
            
            }
            
            if(this.isMobile){this.navBarBrand.addEventListener("touchstart",this.addNavButtonAnimation,false);}
            else{this.navBarBrand.addEventListener("mousedown",this.addNavButtonAnimation,false);}
              
              
              this.navBarBrand.addEventListener('animationend', function(e){
                e.target.style.animationName = '';
                parent.toggleMenu(e,true,e.target.getAttribute("target"));
              }, false);
              
              
              window.addEventListener("resize", this.resizeHandler);
            }
            
}
//end of methods

}

</script>




// WEBPACK FOOTER //
// Navbar.vue?679de284